export default __webpack_public_path__ + "static/media/icon-youtube-2.95e3b735.svg";